import './Navbar.css';
import React, { useEffect, useState } from "react";
import ReferenceButton from './ReferenceButton';
import { LogoutService } from '../services/LogoutService';

export default function Navbar() {
  
  const achat_id = "321";
  const [day, setDay] = useState("...");
  const [time, setTime] = useState("--:--");
  const [date, setDate] = useState("Loading...");

  const logoutService = new LogoutService();

  useEffect(() => {
  const updateClock = () => {
    const now = new Date();
    const dayName = now.toLocaleDateString('fr-FR', { weekday: 'long', timeZone: 'Europe/Paris' });
    const timeStr = now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit', timeZone: 'Europe/Paris' });
    const dateStr = now.toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'Europe/Paris' });
    setDay(dayName);
    setTime(timeStr);
    setDate(dateStr);
  };

  updateClock();
  const intervalId = setInterval(updateClock, 30000);

  return () => clearInterval(intervalId);
}, []);

const handleLogoutClick = async () => {
    try {
      await logoutService.handleLogout();
     
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };


  return (
    <div className='navbar1'>
      <div className="left">
        <div className="clock">
          <div className="clock-top">{day}</div>
          <div className="clock-time">{time}</div>
          <div className="clock-bottom">{date}</div>
        </div>
      </div>
      <div className="rightWrapper">
        <div className="right">
          <h1>BeepoBuy</h1>
          <div className="searchbar1">Barre de recherche</div>
          <div className="barcodeScanner">BarreCode Scanner</div>
          <div className="buttonLogout"  onClick={handleLogoutClick}>Deconnection</div>
        </div>
        <div className="buttonsbar">
          <ReferenceButton to={`/devis_list`}>
            Devis
          </ReferenceButton>
          <ReferenceButton to={`/bon_com_client_list`}>
            Bon de commande Client
          </ReferenceButton>
          <ReferenceButton to={`/achat/${achat_id}`}>
            Achat
          </ReferenceButton>
          <ReferenceButton to={`/bon_com_fournisseur_list`}>
            Bon de commande Fournisseur
          </ReferenceButton>
          <ReferenceButton to={`/gestion_stock`}>
            Gestion du stock
          </ReferenceButton>
          <ReferenceButton to={`/mandat_list`}>
            Mandat
          </ReferenceButton>
          <ReferenceButton to={`/docs`}>
            API
          </ReferenceButton>
        </div>
      </div>
    </div>
  );
}